'use client'

import React, { Suspense } from 'react'
import { LoginForm } from '@/components/LoginForm'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'

function LoginContent() {
  const searchParams = useSearchParams()
  const message = searchParams.get('message')

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold">Bei deinem Konto anmelden</h2>
          {/* <p className="mt-2 text-center text-sm">
            Oder{' '}
            <Link href="/register" className="font-medium text-blue-600 hover:text-blue-500">
              registriere dich für ein neues Konto
            </Link>
          </p> */}
        </div>

        {message === 'password-reset-success' && (
          <div className="rounded-lg border border-green-200 bg-green-50 p-4 text-green-800">
            <p className="text-sm">
              <strong>Erfolgreich!</strong> Dein Passwort wurde zurückgesetzt. Du kannst dich jetzt
              mit deinem neuen Passwort anmelden.
            </p>
          </div>
        )}

        <LoginForm redirectTo="/dashboard" />
      </div>
    </div>
  )
}

export default function LoginPage() {
  return (
    <Suspense
      fallback={<div className="flex min-h-screen items-center justify-center">Loading...</div>}
    >
      <LoginContent />
    </Suspense>
  )
}
